import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../config';
import { defaultRoleData } from '../components/common/Utils';
import { updateLoading } from './Loading';

export const UPDATE_JOB_FIELD_FOR_CUSTOMER_EDIT =
    'UPDATE_JOB_FIELD_FOR_CUSTOMER_EDIT';
export const FETCH_JOB_FOR_CUSTOMER_EDIT = 'FETCH_JOB_FOR_CUSTOMER_EDIT';
export const INIT_ROLE_DATA_FOR_CUSTOMER_EDIT =
    'INIT_ROLE_DATA_FOR_CUSTOMER_EDIT';

export function fetchJob(data) {
    return {
        type: 'FETCH_JOB_FOR_CUSTOMER_EDIT',
        payload: data,
    };
}

export function initRoleData(data) {
    return {
        type: 'INIT_ROLE_DATA_FOR_CUSTOMER_EDIT',
        payload: data,
    };
}

export function updateField(field, data) {
    return {
        type: 'UPDATE_JOB_FIELD_FOR_CUSTOMER_EDIT',
        payload: { field, data },
    };
}

export function fetchJobAsync(jobId) {
    return dispatch => {
        axios({
            method: 'GET',
            url: `${ROOT_URL_V2}jobs/${jobId}/`,
        })
            .then(response => {
                const jobData = response.data.content;
                dispatch(fetchJob(jobData));
                const { service } = jobData;

                const roleData = defaultRoleData;
                Object.keys(roleData[service]).forEach(key => {
                    roleData[service][key] = jobData[key];
                });
                dispatch(initRoleData(roleData));
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error.response);
            });
    };
}

export function sendJobEditRequestAsync(id, data, completion) {
    const payload = {
        service: data.service,
        role: data.role,
        service_role: data.service_role,
        date: data.date,
        duration: data.duration,
        start_time: data.start_time,
        client_pay_per_hour: data.client_pay_per_hour,
        freelancer_pay_per_hour: data.freelancer_pay_per_hour,
        address1: data.address1,
        address2: data.address2,
        postcode: data.postcode,
        client_vat: data.client_vat,
        number_of_freelancers: data.number_of_freelancers,
        freelancers_information: data.freelancers_information,
        admin_information: data.admin_information,
        nature_of_business: data.nature_of_business,
        required_qualifications: data.required_qualifications,
        safety_risks: data.safety_risks,
        available_facilities: data.available_facilities,
        expenses_payable: data.expenses_payable,
        title: data.title,
    };

    return dispatch => {
        dispatch(updateLoading('job-edit', true));
        axios({
            method: 'PATCH',
            url: `${ROOT_URL_V2}jobs/${id}/`,
            data: payload,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                dispatch(updateLoading('job-edit', false));
                completion(response.data, undefined);
                return response;
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.log(error.response);
                completion(undefined, error.response);
                dispatch(updateLoading('job-edit', false));
            });
    };
}
